export const APP_NAME = 'SCAR Dispatcher 2.0';

export const NOT_AVAILABLE = 'N/A';
